import React, { useState } from "react";
import {
  Accordion, AccordionSummary, AccordionDetails,
  Typography, Box,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

export default function FAQs({ faqs }) {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (_, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Box>
      <Box sx={{ textAlign: "center", mb: 6 }}>
        <Typography sx={{ fontWeight: 900, fontSize: { xs: "26px", md: "38px" }, color: "#fff", mb: 1 }}>
          Frequently Asked <Box component="span" sx={{ color: "#FFC001" }}>Questions</Box>
        </Typography>
        <Typography sx={{ color: "#555", fontSize: "14px" }}>
          Everything you need to know about our plans and platform.
        </Typography>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
        {faqs.map((faq, i) => {
          const isOpen = expanded === i;
          return (
            <Accordion
              key={i}
              expanded={isOpen}
              onChange={handleChange(i)}
              disableGutters
              elevation={0}
              sx={{
                backgroundColor: "#1a1a1a",
                border: isOpen ? "1px solid rgba(255,192,1,0.35)" : "1px solid #222",
                borderRadius: "14px !important",
                overflow: "hidden",
                "&:before": { display: "none" },
                transition: "border-color 0.2s",
              }}
            >
              <AccordionSummary
                expandIcon={
                  isOpen
                    ? <RemoveIcon sx={{ color: "#FFC001", fontSize: 18 }} />
                    : <AddIcon sx={{ color: "#666", fontSize: 18 }} />
                }
                sx={{
                  px: 3, py: 1.5, minHeight: "unset",
                  "& .MuiAccordionSummary-content": { my: "12px", alignItems: "center", gap: 1.5 },
                }}
              >
                {faq.icon && (
                  <Box sx={{
                    width: 32, height: 32, borderRadius: "8px", flexShrink: 0,
                    backgroundColor: isOpen ? "rgba(255,192,1,0.12)" : "rgba(255,255,255,0.04)",
                    border: isOpen ? "1px solid rgba(255,192,1,0.2)" : "1px solid #2a2a2a",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    transition: "all 0.2s",
                  }}>
                    <faq.icon sx={{ fontSize: 16, color: isOpen ? "#FFC001" : "#666" }} />
                  </Box>
                )}
                <Typography sx={{ fontWeight: 600, fontSize: { xs: "14px", md: "15px" }, color: isOpen ? "#fff" : "#ccc", lineHeight: 1.4 }}>
                  {faq.title}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ px: 3, pb: 2.5, pt: 0 }}>
                <Typography sx={{ color: "#888", fontSize: "14px", lineHeight: 1.7, pl: faq.icon ? "47px" : 0 }}>
                  {faq.paragraph}
                </Typography>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Box>
    </Box>
  );
}
